<template>
  <SettingGroup title="ロックするキーリスト">
    <div class="transferWrapper">
      <Transfer
        v-if="isReady"
        :transferData="transferOptions"
        :initialSelected="form.keyList"
        leftPanelTitle="ロックするキーリスト"
        rightPanelTitle="選択可能な機能"
        @select="handleSelected"
      />
    </div>
  </SettingGroup>
</template>

<script>
import Transfer from '@/components/pc/radio/ipradio/atoms/Transfer.vue'
import SettingGroup from '@/components/pc/radio/ipradio/organisms/layout/SettingGroup.vue'
import { FUNCTION_LIST } from '@/components/pc/radio/ipradio/config/BCconstants'
import { useRadioSettingsStore } from '@/components/pc/radio/ipradio/stores/bcRadioSettings'
import { mapStores } from 'pinia'

export default {
  name: 'SuperLockKeyListVue2',
  components: { Transfer, SettingGroup },
  data () {
    return {
      form: { keyList: [] },
      isReady: false,
      setting: null, // ストアの一時設定
    }
  },
  computed: {
    ...mapStores(useRadioSettingsStore),

    // Vue 3の transferOptions と同等
    transferOptions () {
      return FUNCTION_LIST
        .map(ele => ele.type && ele.type.superLock
          ? { label: ele.label, key: ele.value, disabled: false }
          : undefined)
        .filter(Boolean)
    },
  },
  created () {
    // ストアから設定を取得
    this.setting = this.radioSettingsStore.getTempSetting()

    // 設定 → フォームへ反映
    this.transSetting2Form()

    // フォーム変更を監視：設定へ反映し保存
    this.$watch('form', () => {
      this.transForm2Setting()
      this.radioSettingsStore.saveTempSetting(this.setting)
    }, { deep: true })
  },
  mounted () {
    this.isReady = true
  },
  methods: {
    deepCopy (o) { try { return JSON.parse(JSON.stringify(o)) } catch (_) { return {} } },

    // フォーム → 設定
    transForm2Setting () {
      const data = this.setting?.KeyAssignment?.SuperLock
      if (!data) return
      // console.log('before setting:', this.deepCopy(data))
      data.keyList = Array.isArray(this.form.keyList) ? this.form.keyList.slice() : []
      // console.log('after setting:', this.deepCopy(data))
    },

    // 設定 → フォーム
    transSetting2Form () {
      const data = this.setting?.KeyAssignment?.SuperLock
      if (!data) return
      // console.log('before form:', this.deepCopy(this.form))
      this.form.keyList = Array.isArray(data.keyList) ? data.keyList.slice() : []
      // console.log('after form:', this.deepCopy(this.form))
    },

    handleSelected (val) {
      this.form.keyList = Array.isArray(val) ? val.slice() : []
    },
  },
}
</script>

<style scoped>
:deep(.el-transfer-panel) { width: calc(500px - 1rem); }
:deep(.el-transfer-panel__body),
:deep(.el-transfer-panel__list) { height: 470px; }
</style>
